import axios from "axios";
import config from "../config";
import { handleUnauthorizedAndRelogin } from "./authSession";

const baseApi = axios.create({
  baseURL: config.baseApiUrl,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const shouldRelogin = (error) => {
  if (error?.response?.status !== 401) return false;

  const message = String(error?.response?.data?.message || "").toLowerCase();
  const reason = String(error?.response?.data?.error || "").toLowerCase();
  const combined = `${message} ${reason}`;

  return (
    combined.includes("invalid token") ||
    combined.includes("token expired") ||
    combined.includes("unauthorized")
  );
};

baseApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error?.config?.url || "";
    const isAuthMeCall =
      typeof requestUrl === "string" && requestUrl.includes("api/auth/me");
    const isAuthCallbackPage =
      typeof window !== "undefined" &&
      window.location.pathname.includes("/auth/callback");

    if (!isAuthMeCall && !isAuthCallbackPage && shouldRelogin(error)) {
      handleUnauthorizedAndRelogin();
    }
    return Promise.reject(error);
  }
);

export default baseApi;
